import {useDispatch, useSelector} from "react-redux";
import {creatableLicense, hideCreateOneReleaseDialog, dialogs, loading} from "../../../store/slice";
import {useState} from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {LocalSpinner} from "../../../../../../shared/components/Spinner";
import DialogActions from "@mui/material/DialogActions";
import {Button} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import {CustomInput} from "../../../../../../shared/components/Inputs";
import {CreateAndReleaseOneLicense} from "../../../store/actions";

export const CreateAndReleaseONELicense = () => {
    const dispatch = useDispatch();
    const license = useSelector(creatableLicense);
    const {createOneRelease: {isOpen}} = useSelector(dialogs);
    const {isLoadingCreateAndReleaseOne} = useSelector(loading);

    const handleClose = () => dispatch(hideCreateOneReleaseDialog());

    const [form, setForm] = useState<{note: string, email: string}>({note: '', email: ''});

    const handleUpdateNote = (value: string) => {setForm({...form, note: value})};
    const handleUpdateEmail = (value: string) => {setForm({...form, email: value})};

    const handleSendForm = () => {
        if(license){
            dispatch(CreateAndReleaseOneLicense({license, note: form.note, email: form.email}));
        }
    }

    const isOk = () => license && form.note.trim().length > 0;

    return(
        <Dialog open={isOpen} onClose={handleClose}>
            <DialogTitle>Create & Release License</DialogTitle>

            <DialogContent>
                <CustomInput
                    sx={{margin: '15px 0 0 0'}}
                    style={{margin: '15px 0 0 0'}}
                    value={form.note}
                    onChange={(e) => handleUpdateNote(e.target.value as string)}
                    multiline
                    minRows={5}
                    label={'Note'}
                />

                <CustomInput
                    type={'email'}
                    value={form.email}
                    onChange={(e) => handleUpdateEmail(e.target.value as string)}
                    label={'Email (leave it blank if not needed.)'}
                    sx={{width: '70%', margin: '15px 0 0 0'}}
                />

            </DialogContent>

            {isLoadingCreateAndReleaseOne ?
                <LocalSpinner />
                :
                <DialogActions>
                    <Button onClick={handleClose} color={'warning'}>Cancel</Button>
                    <Button onClick={handleSendForm} disabled={!isOk()} color={'success'}>Create & Release</Button>
                </DialogActions>
            }
        </Dialog>
    )
}